<template>
  <ts-panel>
    <ts-panel-wrapper class="tw-space-y-2">
      <h1 class="section-divider-underline">
        {{ $t("examRegister.examRegisted") }}
      </h1>
      <div class="row tw-space-y-4">
        <div class="col-md-12">
          <label class="form-label col-form-label col-md-12">{{
            $t("search")
          }}</label>
          <div class="col-md-12">
            <input type="text" v-model="search" class="form-control" />
          </div>
        </div>
        <div
          class="tw-overflow-y-scroll col-12"
          style="max-height: 62vh; height: 62vh"
        >
          <table class="tw-w-full">
            <thead>
              <tr
                class="tw-uppercase tw-bg-gray-200 tw-h-10 tw-sticky tw-top-0"
              >
                <!-- <th style="width: 20%" class="tw-pl-2">
                  {{ $t("examRegister.cardNumber") }}
                </th> -->
                <th style="width: 25%" class="tw-pl-2 tw-whitespace-no-wrap">
                  {{ $t("examRegister.nameEn") }}
                </th>
                <th
                  style="width: 15%"
                  class="tw-text-center tw-whitespace-no-wrap"
                >
                  {{ $t("examRegister.sex") }}
                </th>
                <th style="width: 20%" class="tw-whitespace-no-wrap">
                  {{ $t("examRegister.registerDate") }}
                </th>
                <th style="width: 15%" class="tw-whitespace-no-wrap">
                  {{ $t("examRegister.phone") }}
                </th>
                <th style="width: 5%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="errors.has('candidate_list')">
                <td class="tw-text-red-500 tw-h-10 tw-text-center" colspan="5">
                  {{ errors.first("candidate_list") }}
                </td>
              </tr>
              <tr
                v-for="(candidate, index) in candidateRegisteds"
                :key="index"
                class="tw-cursor-pointer hover:tw-bg-gray-300 tw-w-full tw-h-10"
                @click="removeRow(candidate)"
              >
                <!-- <td class="tw-whitespace-no-wrap tw-pl-2">
                  {{ candidate.card_number }}
                </td> -->
                <td class="tw-whitespace-no-wrap tw-pl-2">
                  {{ candidate.full_name_en }}
                </td>
                <td class="tw-whitespace-no-wrap tw-text-center">
                  {{ candidate.sex }}
                </td>
                <td class="tw-whitespace-no-wrap">
                  {{ candidate.register_date }}
                </td>
                <td class="tw-whitespace-no-wrap">
                  {{ candidate.phone }}
                </td>
                <td
                  class="tw-whitespace-no-wrap tw-text-red-500 tw-text-center"
                >
                  <a-icon type="minus-circle" class="tw-text-lg" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ts-panel-wrapper>
  </ts-panel>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";

export default {
  name: "exam-registed",
  props: ["value", "validation"],
  data() {
    return {
      search: "",
      model: {},
      errors: new Errors(),
      options: null,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("academic/examRegister", ["formViewDatas", "edit_data"]),
    candidateRegisteds() {
      return this.model.candidateRegisted
        .filter(
          (c) =>
            this.search
              .split(" ")
              .every((s) =>
                c.full_name_en.toLowerCase().includes(s.toLowerCase())
              ) ||
            this.search
              .split(" ")
              .every((s) =>
                c.card_number.toLowerCase().includes(s.toLowerCase())
              )
        )
        .slice(0, 400);
    },
  },
  methods: {
    removeRow(candidate) {
      this.model.candidate_list.splice(
        this.model.candidate_list.indexOf(candidate.candidate_id),
        1
      );
      this.model.candidateRegisted.splice(
        this.model.candidateRegisted.indexOf(candidate),
        1
      );
    },
    clearOption() {
      this.model.status_reason_id = null;
      this.options = null;
    },
  },
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
